import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead';
import { Employee } from 'src/app/core/models/employee';
import { EmployeeService } from 'src/app/core/services/employee.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-impersonation',
  templateUrl: './impersonation.component.html',
})
export class ImpersonationComponent implements OnInit {
  employees: Employee[] = [];
  inputName = '';
  selectedEmail = '';
  isLoading = false;
  errorMessage = '';

  constructor(
    private employeeService: EmployeeService,
    private router: Router,
  ) {}

  ngOnInit() {
    if (environment.production) {
      this.router.navigate(['/external']);
      return;
    }
    this.employeeService.employeeList().toPromise()
      .then(res => this.employees = res)
      .catch(() => this.errorMessage = 'Failed to load employees.');
  }

  onSelectEmployee(event: TypeaheadMatch) {
    const emp: Employee = event.item;
    this.selectedEmail = emp.email;
    this.errorMessage = '';
  }

  submit() {
    if (!this.selectedEmail) return;
    this.isLoading = true;
    this.errorMessage = '';
    this.employeeService.transform(this.selectedEmail).toPromise()
      .then(() => window.location.reload())
      .catch(err => {
        this.isLoading = false;
        this.errorMessage = err?.error || 'Employee not found or an error occurred.';
      });
  }
}
